import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { generateI18nInitOptions } from './settings';

export const i18nInstance = i18n;

i18nInstance.use(initReactI18next).init(generateI18nInitOptions(), (error) => {
  // eslint-disable-next-line no-console
  error && console.error(error);
});
